import { createContext, useContext } from 'react';

export type ApnsToastContextType = {
  showToast: (message: string) => void;
};

export const ApnsToastContext = createContext<ApnsToastContextType>({
  showToast: () => {},
});

export const useApnsToast = () => useContext(ApnsToastContext);
